/*
 * @Author: YuanYuan
 * @Date: 2024-02-04 16:44:00
 * @LastEditTime: 2024-04-12 17:21:55
 * @description: components/global 文件夹中组件全都注册为全局组件
 * components/base 文件夹中组件不是全局组件，需要在使用的文件中手动引入
 */
const components = {}
const context = require.context('./', true, /^\.\/.*?\.vue$/)

context.keys().forEach(key => {
  const name = key.replace(/\.\/(.*)?\.vue/, (str, $1) => $1)
  components[name] = context(key).default
})

export default {
  install: Vue => {
    Object.keys(components).forEach(key => {
      Vue.component(key, components[key])
    })
  }
}
